var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 18,
  viewBox: "0 0 11 18",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 2L9 9L2 16",
  stroke: "#233750",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default __webpack_public_path__ + "static/media/Right_arrow.f2ebbaaf.svg";
export { SvgRightArrow as ReactComponent };